import script from "./DestinationStrip.vue?vue&type=script&setup=true&lang=js"
export * from "./DestinationStrip.vue?vue&type=script&setup=true&lang=js"

import "./DestinationStrip.vue?vue&type=style&index=0&id=74f4700c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74f4700c"]])

export default __exports__